import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import TermsUpdateUI from './TermsUpdateUI.js'

class TermsUpdateSF extends Component {
  constructor(props) {
    super(props)
    let dsraPercentF3
    let depositPercentF3
    if (this.props.loan.sanction.dsraPercent === 0)
      dsraPercentF3 = '0'
    else
      dsraPercentF3 = this.props.loan.sanction.dsraPercent
    if (this.props.loan.sanction.depositPercent === 0)
      depositPercentF3 = '0'
    else
      depositPercentF3 = this.props.loan.sanction.depositPercent

    this.state = {
      successMsg: null,
      errorList: null,
      //
      loanName: this.props.loan.loanName || '',
      loanNameError: null,
      //
      termSheetAmount: this.props.loan.termSheet.amountF || this.props.loan.loanRequest.amountF || '',
      termSheetAmountError: null,
      //
      termSheetTenureMonths: (this.props.loan.loanType === 'interest_only' && this.props.loan.facilityTenureMonths)
        ? this.props.loan.facilityTenureMonths
        : (this.props.loan.termSheet.tenureMonths || this.props.loan.loanRequest.tenureMonths || ''),
      termSheetTenureMonthsError: null,
      //
      interestTenureMonths: this.props.loan.termSheet.interestMonths || '',
      interestTenureMonthsError: null,
      showInterestTenureMonths: this.props.loan.loanType == 'int_then_prj' || false,
      //
      termSheetInterestRate: this.props.loan.termSheet.interestRate || '',
      termSheetInterestRateError: null,
      //
      termSheetApr: this.props.loan.termSheet.apr || '',
      termSheetAprError: null,
      //
      processingFeePercent: this.props.loan.termSheet.processingFeePercent || '',
      processingFeePercentError: null,
      processingFee: this.props.loan.termSheet.processingFeePercent * this.props.loan.termSheet.amountF / 100,
      //
      promoterFundF3: this.props.loan.sanction.promoterFundF3 || '',
      promoterFundF3Error: null,
      //
      totalProjectCost: this.props.loan.projectTotalF3 || '',
      totalProjectCostError: null,
      //
      dsraPercent: dsraPercentF3 || '',
      dsraPercentError: null,
      dsra: dsraPercentF3 * this.props.loan.termSheet.amountF / 100,
      //
      dsraMonths: this.props.loan.sanction.dsraMonths || '',
      dsraMonthsError: null,
      //
      dsraInterest: this.props.loan.sanction.dsraInterest || '',
      //
      additionalDsraPercent: this.props.loan.sanction.additionalDsraPercent || '',
      additionalDsraPercentError: null,
      additionalDsraMonths: this.props.loan.sanction.additionalDsraMonths || '',
      additionalDsraMonthsError: null,
      additionalDsraDueDate: this.props.loan.sanction.additionalDsraDueDate || '',
      //
      dsraReleaseAmount: this.props.loan.sanction.dsraReleaseAmountF || '',
      dsraReleaseAmountError: null,
      //
      loanTenureMonths: this.props.loan.termSheet.loanTenureMonths || '',
      LoanTenureMonthsError: null,
      //
      depositPercent: depositPercentF3 || '',
      depositPercentError: null,
      deposit: depositPercentF3 * this.props.loan.termSheet.amountF / 100,
      //
      followUpLoan: this.props.loan.followUpLoan,
      //
      loanType: this.props.loan.loanType || '',
      loanTypeError: null,
      loanTypeList: [],
      //
      loanSubType: this.props.loan.loanSubType || '',
      loanSubTypeError: null,
      loanSubTypeList: [],
      //
      numberOfRevolves: this.props.loan.numberOfRevolves || '',
      numberOfRevolvesError: null,
      // form events
      submitted: false,
      moratoriumMode: (this.props.loan.moratoriumPeriod && this.props.loan.moratoriumInterestRate && this.props.loan.postMoratoriumInterestRate) !== null ? true : false,
      constructionMode: (this.props.loan.constructionPeriod && this.props.loan.constructionInterestRate && this.props.loan.postConstructionInterestRate) !== null ? true : false,
      moratoriumPeriod: this.props.loan.moratoriumPeriod || '',
      moratoriumPeriodError: null,
      moratoriumInterestRate: this.props.loan.moratoriumInterestRate || '',
      moratoriumInterestRateError: null,
      postMoratoriumInterestRate: this.props.loan.postMoratoriumInterestRate || '',
      postMoratoriumInterestRateError: null,
      constructionPeriod: this.props.loan.constructionPeriod || '',
      constructionPeriodError: null,
      constructionInterestRate: this.props.loan.constructionInterestRate || '',
      constructionInterestRateError: null,
      postConstructionInterestRate: this.props.loan.postConstructionInterestRate || '',
      postConstructionInterestRateError: null,

    }
  }

  render() {

    return (
      <TermsUpdateUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        loanTypeList={this.state.loanTypeList}
        loan={this.props.loan}
        isOpen={this.props.isOpen}
        onCancelClick={this.props.onCancelClick}
        //
        loanName={this.state.loanName}
        onLoanNameChange={(event) => { this.setState({ loanName: event.target.value }) }}
        loanNameError={this.state.loanNameError}
        setLoanNameError={(error) => { this.setState({ loanNameError: error }) }}
        //
        termSheetAmount={this.state.termSheetAmount}
        onTermSheetAmountChange={(event) => { this.setState({ termSheetAmount: event.target.value }) }}
        termSheetAmountError={this.state.termSheetAmountError}
        setTermSheetAmountError={(error) => { this.setState({ termSheetAmountError: error }) }}
        //
        termSheetTenureMonths={this.state.termSheetTenureMonths}
        onTermSheetTenureMonthsChange={(event) => { this.setState({ termSheetTenureMonths: event.target.value }) }}
        termSheetTenureMonthsError={this.state.termSheetTenureMonthsError}
        setTermSheetTenureMonthsError={(error) => { this.setState({ termSheetTenureMonthsError: error }) }}
        //
        interestTenureMonths={this.state.interestTenureMonths}
        onInterestTenureMonthsChange={(event) => { this.setState({ interestTenureMonths: event.target.value }) }}
        interestTenureMonthsError={this.state.interestTenureMonthsError}
        setInterestTenureMonthsError={(error) => { this.setState({ interestTenureMonthsError: error }) }}
        showInterestTenureMonths={this.state.showInterestTenureMonths}
        //
        termSheetInterestRate={this.state.termSheetInterestRate}
        onTermSheetInterestRateChange={(event) => { this.setState({ termSheetInterestRate: event.target.value }) }}
        termSheetInterestRateError={this.state.termSheetInterestRateError}
        setTermSheetInterestRateError={(error) => { this.setState({ termSheetInterestRateError: error }) }}
        //
        termSheetApr={this.state.termSheetApr}
        onTermSheetAprChange={(event) => { this.setState({ termSheetApr: event.target.value }) }}
        termSheetAprError={this.state.termSheetAprError}
        setTermSheetAprError={(error) => { this.setState({ termSheetAprError: error }) }}
        //
        processingFeePercent={this.state.processingFeePercent}
        onProcessingFeePercentChange={this.onProcessingFeePercentChange}
        processingFeePercentError={this.state.processingFeePercentError}
        setProcessingFeePercentError={(error) => { this.setState({ processingFeePercentError: error }) }}
        processingFee={this.state.processingFee}
        //
        promoterFundF3={this.state.promoterFundF3}
        onPromoterFundF3Change={(event) => { this.setState({ promoterFundF3: event.target.value }) }}
        promoterFundF3Error={this.state.promoterFundF3Error}
        setPromoterFundF3Error={(error) => { this.setState({ promoterFundF3Error: error }) }}
        //
        totalProjectCost={this.state.totalProjectCost}
        onTotalProjectCostChange={(event) => { this.setState({ totalProjectCost: event.target.value }) }}
        totalProjectCostError={this.state.totalProjectCostError}
        setTotalProjectCostError={(error) => { this.setState({ totalProjectCostError: error }) }}
        //
        dsraPercent={this.state.dsraPercent}
        onDsraPercentChange={this.onDsraPercentChange}
        dsraPercentError={this.state.dsraPercentError}
        setDsraPercentError={(error) => { this.setState({ dsraPercentError: error }) }}
        dsra={this.state.dsra}
        //
        dsraMonths={this.state.dsraMonths}
        onDsraMonthsChange={(event) => { this.setState({ dsraMonths: event.target.value }) }}
        dsraMonthsError={this.state.dsraMonthsError}
        setDsraMonthsError={(error) => { this.setState({ dsraMonthsError: error }) }}
        //
        dsraInterest={this.state.dsraInterest}
        onDsraInterestChange={() => { this.setState({ dsraInterest: !this.state.dsraInterest }) }}
        //
        additionalDsraPercent={this.state.additionalDsraPercent}
        onAdditionalDsraPercentChange={(event) => { this.setState({ additionalDsraPercent: event.target.value }) }}
        additionalDsraPercentError={this.state.additionalDsraPercentError}
        setAdditionalDsraPercentError={(error) => { this.setState({ additionalDsraPercentError: error }) }}
        additionalDsraMonths={this.state.additionalDsraMonths}
        onAdditionalDsraMonthsChange={(event) => { this.setState({ additionalDsraMonths: event.target.value }) }}
        additionalDsraMonthsError={this.state.additionalDsraMonthsError}
        setAdditionalDsraMonthsError={(error) => { this.setState({ additionalDsraMonthsError: error }) }}
        additionalDsraDueDate={this.state.additionalDsraDueDate}
        onAdditionalDsraDueDateChange={(dateISO) => { this.setState({ additionalDsraDueDate: dateISO }) }}
        //
        dsraReleaseAmount={this.state.dsraReleaseAmount}
        onDsraReleaseAmountChange={(event) => { this.setState({ dsraReleaseAmount: event.target.value }) }}
        dsraReleaseAmountError={this.state.dsraReleaseAmountError}
        setDsraReleaseAmountError={(error) => { this.setState({ dsraReleaseAmountError: error }) }}
        //
        loanTenureMonths={this.state.loanTenureMonths}
        onLoanTenureMonthsChange={(event) => { this.setState({ loanTenureMonths: event.target.value }) }}
        loanTenureMonthsError={this.state.loanTenureMonthsError}
        setLoanTenureMonthsError={(error) => { this.setState({ loanTenureMonthsError: error }) }}
        //
        followUpLoan={this.state.followUpLoan}
        onFollowUpLoanChange={(event) => { this.setState({ followUpLoan: !this.state.followUpLoan }) }}
        //
        loanType={this.state.loanType}
        onLoanTypeChange={this.onLoanTypeChange}
        loanTypeError={this.state.loanTypeError}
        setLoanTypeError={(error) => { this.setState({ loanTypeError: error }) }}
        //
        loanSubType={this.state.loanSubType}
        onLoanSubTypeChange={this.onLoanSubTypeChange}
        loanSubTypeError={this.state.loanSubTypeError}
        setLoanSubTypeError={(error) => { this.setState({ loanSubTypeError: error }) }}
        loanSubTypeList={this.state.loanSubTypeList}
        //
        numberOfRevolves={this.state.numberOfRevolves}
        onNumberOfRevolvesChange={(event) => { this.setState({ numberOfRevolves: event.target.value }) }}
        numberOfRevolvesError={this.state.numberOfRevolvesError}
        setNumberOfRevolvesError={(error) => { this.setState({ numberOfRevolvesError: error }) }}
        // form events
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        setErrorList={this.setErrorList}
        //
        onToggleMoratorium={() => { this.setState({ moratoriumMode: !this.state.moratoriumMode, constructionMode: false }) }}
        moratorium={this.state.moratoriumMode}
        //
        onToggleConstruction={() => { this.setState({ constructionMode: !this.state.constructionMode, moratoriumMode: false }) }}
        construction={this.state.constructionMode}
        //
        moratoriumPeriod={this.state.moratoriumPeriod}
        onMoratoriumPeriodChange={(event) => { this.setState({ moratoriumPeriod: event.target.value }) }}
        moratoriumPeriodError={this.state.moratoriumPeriodError}
        setMoratoriumPeriodError={(error) => { this.setState({ moratoriumPeriodError: error }) }}
        //
        moratoriumInterestRate={this.state.moratoriumInterestRate}
        onMoratoriumInterestRateChange={(event) => { this.setState({ moratoriumInterestRate: event.target.value }) }}
        moratoriumInterestRateError={this.state.moratoriumInterestRateError}
        setMoratoriumInterestRateError={(error) => { this.setState({ moratoriumInterestRateError: error }) }}
        //
        postMoratoriumInterestRate={this.state.postMoratoriumInterestRate}
        onPostMoratoriumInterestRateChange={(event) => { this.setState({ postMoratoriumInterestRate: event.target.value }) }}
        postMoratoriumInterestRateError={this.state.postMoratoriumInterestRateError}
        setPostMoratoriumInterestRateError={(error) => { this.setState({ postMoratoriumInterestRateError: error }) }}
        //
        constructionPeriod={this.state.constructionPeriod}
        onConstructionPeriodChange={(event) => { this.setState({ constructionPeriod: event.target.value }) }}
        constructionPeriodError={this.state.constructionPeriodError}
        setConstructionPeriodError={(error) => { this.setState({ constructionPeriodError: error }) }}
        //
        constructionInterestRate={this.state.constructionInterestRate}
        onConstructionInterestRateChange={(event) => { this.setState({ constructionInterestRate: event.target.value }) }}
        constructionInterestRateError={this.state.constructionInterestRateError}
        setConstructionInterestRateError={(error) => { this.setState({ constructionInterestRateError: error }) }}
        //
        postConstructionInterestRate={this.state.postConstructionInterestRate}
        onPostConstructionInterestRateChange={(event) => { this.setState({ postConstructionInterestRate: event.target.value }) }}
        postConstructionInterestRateError={this.state.postConstructionInterestRateError}
        setPostConstructionInterestRateError={(error) => { this.setState({ postConstructionInterestRateError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoanSubTypeList(context)
    this.getLoanTypeList(context)
  }

  getLoanTypeList(context) {
    let cacheManager = new CacheManager({
      resource: `/api/reference/loanTypes`,
      cacheKey: CacheKeys.LoanTypeList(),
      callback: this.getLoanTypeListCallback,
      ttlInSecs: 36000
    })
    cacheManager.getObject2(context)
  }

  getLoanTypeListCallback = (response) => {
    if (response.keyValueList) {
      this.setState({ loanTypeList: response.keyValueList })
    }
  }

  getLoanSubTypeList(context) {
    let cacheManager = new CacheManager({
      resource: `/api/reference/loan/subTypes`,
      cacheKey: CacheKeys.LoanSubTypeList(),
      callback: this.getLoanSubTypeListCallback,
      ttlInSecs: 36000
    })
    cacheManager.getObject2(context)
  }

  getLoanSubTypeListCallback = (response) => {
    let loanSubTypeList = response.loanSubTypeList.map((loanSubType) => {
      return { key: loanSubType.code, value: loanSubType.title }
    });
    this.setState({ errorList: response.errorList, loanSubTypeList: loanSubTypeList })
  }

  isPhaseVisible = () => {
    const { loanType, loanSubType } = this.state
    return (loanType === 'project' || loanType === 'int_then_prj') && loanSubType === 'ppa'
  }

  onLoanTypeChange = (event) => {
    const loanType = event.target.value
    const showPhase = (loanType === 'project' || loanType === 'int_then_prj') && this.state.loanSubType === 'ppa'
    this.setState({
      loanType,
      showInterestTenureMonths: loanType === 'int_then_prj',
      ...(showPhase ? {} : { moratoriumMode: false, constructionMode: false }),
    })
  }

  onLoanSubTypeChange = (event) => {
    const loanSubType = event.target.value
    const showPhase = (this.state.loanType === 'project' || this.state.loanType === 'int_then_prj') && loanSubType === 'ppa'
    this.setState({
      loanSubType,
      ...(showPhase ? {} : { moratoriumMode: false, constructionMode: false }),
    })
  }

  onProcessingFeePercentChange = (event) => {
    let processingFee = event.target.value * this.state.termSheetAmount / 100
    this.setState({
      processingFeePercent: event.target.value,
      processingFee: processingFee
    })
  }

  onDsraPercentChange = (event) => {
    let dsra = event.target.value * this.state.termSheetAmount / 100
    this.setState({
      dsraPercent: event.target.value,
      dsra: dsra
    })
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/termSheet`,
      this.onSubmitCallback, {
      loanName: this.state.loanName,
      termSheetAmountF: this.state.termSheetAmount,
      termSheetTenureMonths: this.state.termSheetTenureMonths,
      interestTenureMonths: this.state.interestTenureMonths,
      termSheetInterestRate: this.state.termSheetInterestRate,
      termSheetApr: this.state.termSheetApr,
      processingFeePercent: this.state.processingFeePercent,
      promoterFundF: this.state.promoterFundF3,
      totalProjectCostF: this.state.totalProjectCost,
      dsraPercent: this.state.dsraPercent,
      dsraMonths: this.state.dsraMonths,
      dsraInterest: this.state.dsraInterest,
      additionalDsraPercent: this.state.additionalDsraPercent,
      additionalDsraMonths: this.state.additionalDsraMonths,
      additionalDsraDueDate: this.state.additionalDsraDueDate,
      dsraReleaseAmountF: this.state.dsraReleaseAmount,
      loanTenureMonths: this.state.loanTenureMonths,
      depositPercent: this.state.depositPercent,
      followUpLoan: this.state.followUpLoan,
      loanType: this.state.loanType,
      moratorium: this.isPhaseVisible() && this.state.moratoriumMode,
      moratoriumPeriod: this.isPhaseVisible() && this.state.moratoriumMode ? this.state.moratoriumPeriod : null,
      moratoriumInterestRate: this.isPhaseVisible() && this.state.moratoriumMode ? this.state.moratoriumInterestRate : null,
      postMoratoriumInterestRate: this.isPhaseVisible() && this.state.moratoriumMode ? this.state.postMoratoriumInterestRate : null,
      construction: this.isPhaseVisible() && this.state.constructionMode,
      constructionPeriod: this.isPhaseVisible() && this.state.constructionMode ? this.state.constructionPeriod : null,
      constructionInterestRate: this.isPhaseVisible() && this.state.constructionMode ? this.state.constructionInterestRate : null,
      postConstructionInterestRate: this.isPhaseVisible() && this.state.constructionMode ? this.state.postConstructionInterestRate : null,
      loanSubType: (this.state.loanType === 'project' || this.state.loanType === 'int_then_prj' || this.state.loanType === 'interest_only') ? this.state.loanSubType : null
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
      switch (error.fieldName) {
        case 'loanNameF':
          this.setState({ loanNameError: error.message })
          break;
        case 'termSheetAmountF':
          this.setState({ termSheetAmountError: error.message })
          break;
        case 'termSheetTenureMonths':
          this.setState({ termSheetTenureMonthsError: error.message })
          break;
        case 'interestTenureMonths':
          this.setState({ interestTenureMonthsError: error.message })
          break;
        case 'termSheetInterestRate':
          this.setState({ termSheetInterestRateError: error.message })
          break;
        case 'termSheetApr':
          this.setState({ termSheetAprError: error.message })
          break;
        case 'processingFeePercent':
          this.setState({ processingFeePercentError: error.message })
          break;
        case 'promoterFundF3':
          this.setState({ promoterFundF3Error: error.message })
          break;
        case 'totalProjectCostF':
          this.setState({ totalProjectCostError: error.message })
          break;
        case 'dsraPercent':
          this.setState({ dsraPercentError: error.message })
          break;
        case 'dsraMonths':
          this.setState({ dsraMonthsError: error.message })
          break;
        case 'dsraReleaseAmountF':
          this.setState({ dsraReleaseAmountError: error.message })
          break;
        case 'depositPercent':
          this.setState({ depositPercentError: error.message })
          break;
        case 'loanType':
          this.setState({ loanTypeError: error.message })
          break;
        case 'loanSubType':
          this.setState({ loanSubTypeError: error.message })
          break;
        case 'loanTenureMonths':
          this.setState({ loanTenureMonthsError: error.message })
          break;
        case 'dsraReleaseAmountF':
          this.setState({ dsraReleaseAmountError: error.message })
          break;
        default:
      }
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      CacheManager.removeObject(CacheKeys.Loan(this.props.loan.loanId))
      CacheManager.removeObject(CacheKeys.LoanApr(this.props.loan.loanId))
      setTimeout(() => {
        this.setState({ successMsg: null })
        this.props.onCancelClick()
        this.props.onRefreshClick('noBusy')
      }, 800)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
    if (errorList && errorList.length > 0)
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }

}

export default TermsUpdateSF
